import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import Indicador from "model/indicadores/Indicador";
import { IndicadorAnaliseColeta } from "model/indicadores/IndicadorAnaliseColeta";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Paginator } from "primereact/paginator";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import IndicadorMinhasAnalisesColetasService from "service/indicadores/IndicadorMinhasAnalisesColetasService";
import IndicadorService from "service/indicadores/IndicadorService";
import { converterData } from "utils/convert";

interface Props {
    visible: boolean;
    onHide: () => void;
    indicadorId: number;
}

const service = new IndicadorMinhasAnalisesColetasService();
const indicadorService = new IndicadorService();
export default function ModalAnaliseColetaIndicador(props: Props) {
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();
    const [indicador, setIndicador] = useState<Indicador | null>(null);
    const [index, setIndex] = useState<number>(0);

    useEffect(() => {
        startLoading();
        service.buscarPorIndicador(props.indicadorId).then(resposta => {
            resposta.itens = resposta.itens.reverse();
            const index = resposta.itens.findIndex((c) => c.coleta?.status === "CRIADA");
            if (index == -1) {
                setIndex(resposta.itens.length - 1);
            } else {
                setIndex(index);
            }
            setIndicador(resposta);
            stopLoading();
        }).catch(error => {
            console.error(error);
            stopLoading();
        })
    }, [])


    function salvarAnalise(index: number) {
        startLoading();
        let analise: IndicadorAnaliseColeta = new IndicadorAnaliseColeta();
        analise.idColeta = indicador?.itens[index].coleta?.id || 0;
        analise.analise = indicador?.itens[index].coleta?.analise || '';

        service.analisar(analise)
            .then(() => {
                msgSucesso('Indicador Coleta', 'Registro gravado com sucesso');
                let coleta = indicador?.itens[index].coleta;
                if (coleta) {
                    coleta.status = 'ANALISADA';
                    setIndicador({ ...indicador } as Indicador);
                }
                stopLoading();
            })
            .catch(error => {
                console.error(error);
                if (error && error.data && error.data.message) {
                    msgErro('Indicador Coleta', error.data.message);
                } else {
                    msgErro('Indicador Coleta', 'Ocorreu um erro ao tentar gravar, tente novamente!');
                }
                stopLoading();
            });
    }

    return (
        <>
            <Dialog visible={props.visible} style={{ width: '65vw' }} modal onHide={props.onHide}
                header="Análise de coletas">

                {indicador && indicador.itens.length > 0 ? <div>
                    <div style={{ display: 'flex', flexDirection: "row" }}>
                        <Label>Data da coleta: </Label>
                        <span style={{ marginLeft: 8 }}>{converterData(indicador.itens[index].coleta?.dataColeta)}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: "row" }}>
                        <Label>Usuário Coleta: </Label>
                        <span style={{ marginLeft: 8 }}>{indicador.itens[index].coleta?.usuarioColeta?.nome}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: "row" }}>
                        <Label>Valor:</Label>
                        <span style={{ marginLeft: 8 }}>{indicador.itens[index].coleta?.valorColeta?.toString().replaceAll(".", ",")}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: "row" }}>
                        <Label>Meta:</Label>
                        <span style={{ marginLeft: 8 }}>{indicador.itens[index]?.meta ? indicadorService.getTipoMeta(indicador.itens[index]?.meta?.tipo || "").simbolo + " " + indicador.itens[index]?.meta?.meta || 0 : ""}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: "row" }}>
                        <Label>Status:</Label>
                        <span style={{ marginLeft: 8 }}>{service.getStatus(indicador.itens[index].coleta?.status || "")}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: "column" }}>
                        <Label>Observação da coleta</Label>
                        <InputTextarea value={indicador.itens[index].coleta?.observacao || ""} disabled />
                    </div>
                    <div style={{ display: 'flex', flexDirection: "row", marginTop: 8 }}>
                        <Label>Usuário Análise: </Label>
                        <span style={{ marginLeft: 8 }}>{indicador.itens[index].coleta?.usuarioAnalise?.nome || ""}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: "column" }}>
                        <Label>Observação da análise</Label>
                        <InputTextarea value={indicador.itens[index].coleta?.analise || ""} disabled={indicador.itens[index].coleta?.status != "CRIADA"} onChange={(e) => {
                            let coleta = indicador.itens[index].coleta;
                            if (coleta) {
                                coleta.analise = e.target.value;
                                setIndicador({ ...indicador });
                            }

                        }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'flex-end', marginTop: 8, marginBottom: 8 }}>
                        {indicador.itens[index].coleta?.status == "CRIADA" ? <Button label="Enviar análise" onClick={() => salvarAnalise(index)} /> : null}
                    </div>
                </div> : null}
                <Paginator
                    rows={1}
                    first={index}
                    totalRecords={indicador?.itens.length || 0}
                    onPageChange={(e) => {
                        setIndex(e.page);
                    }}
                />
            </Dialog>
        </>
    )
}